import eventBus from '@/event_bus'
import { HOST, MESSAGE_NAME } from '@/constants/message'
import {
    APPEND_MESSAGE,
    APPEND_MESSAGE_ONLY_FRONT_END,
    RESEND_MESSAGE,
    INSERT_MESSAGE
} from '@/constants/pub_sub'
import html2Str from '@/utils/message_render/text_format_from_front_end'
import store from '@/store'

/**
 * 发消息，格式化前端和后端各自需要的格式
 * @param { Object } data
 * @param { String } data.type - base | event | ext，主要用于消息 post 请求
 * @param { String } data.detailType - MESSAGE_NAME
 * @param { Object | String } data.content - 消息内容
 * @param { Number } [data.timeout] - 消息自动删除的倒计时，目前无用。
 * 对于 APPEND_MESSAGE，由于涉及网络请求，不能直接通过该参数进行倒计时
 * @param { String } [data.messageId] - 目前仅用于消息重发，通过 id 查找 idFromServer 等其他消息字段
 * @returns { Object }
 */
function formatSendMessage ({
    type,
    detailType,
    content,
    timeout,
    messageId,
    server
}) {
    const result = {
        backEnd: {
            type,
            // detail_type: detailType,
            // 特殊情况：语音翻译 先转为 text类型 后再发送
            detail_type: detailType === MESSAGE_NAME.AUDIO_TRANSLATION ? MESSAGE_NAME.TEXT : detailType,
            data: detailType === MESSAGE_NAME.TEXT ? html2Str(content) : content
        },
        frontEnd: {
            name: detailType,
            host: HOST.USER,
            content,
            timeout
        }
    }
    if (messageId) {
        result.messageId = messageId
    }
    if (server) {
        result.frontEnd.server = server
    }

    return result
}

function openSkillGroupPop (content) {
    const { isSupportHuman, chatTarget, skill_group } = store.state
    const isTurnHuman = turnHumanServiceText.includes(content)  // 转人工
    const isSupport = isSupportHuman === 'all'   // 会话模式为[机器人和人工]
    const isEnable = skill_group.enable // 在线客服开启[访客选择客服组]
    const isGroupsExist = skill_group.list.length // 技能组入口数据已配置
    const chatWithRobot = chatTarget === 'robot'  // 当前为机器人聊天
    if (isTurnHuman && isSupport && isEnable && isGroupsExist && chatWithRobot && !skill_group.pop) {
        store.commit('setSkillGroup', {
            key: 'pop',
            value: true
        })
        return true
    }
    return false
}

/**
 * 向消息列表插入消息并 POST 请求
 * 用于大部分场景，如点击热点词汇、文本输入框、语音转文字后的消息发送等
 */
export const turnHumanServiceText = [ 'rg', '转人工', '人工' ]
export function sendMessage ({
    type,
    detailType,
    content,
    server
}) {
    if (openSkillGroupPop(content)) return

    eventBus.$emit(APPEND_MESSAGE, formatSendMessage({
        type,
        detailType,
        content,
        server
    }))
}

/**
 * 仅向消息列表插入消息，但不 POST 请求
 * 用于：微信语音（MESSAGE_NAME.AUDIO 并含 localId 字段）消息
 */
export function sendMessageOnlyFrontEnd ({
    type,
    detailType,
    content,
    timeout
}) {
    eventBus.$emit(APPEND_MESSAGE_ONLY_FRONT_END, formatSendMessage({
        type,
        detailType,
        content,
        timeout
    }))
}

/**
 * 向消息列表的特定位置（指定 baseMessageId 为基准后面）插入消息并 POST 请求
 * 用于：微信语音转文字的文本消息（需插入在相应语音的后一位）
 */
export function sendMessageAndInsert ({
    type,
    detailType,
    content,
    timeout
}, baseMessageId) {
    eventBus.$emit(INSERT_MESSAGE, formatSendMessage({
        type,
        detailType,
        content,
        timeout
    }), baseMessageId)
}

/**
 * 重发消息
 */
export function resendMessage ({
    type,
    detailType,
    content,
    messageId
}) {
    eventBus.$emit(RESEND_MESSAGE, formatSendMessage({
        type,
        detailType,
        content,
        messageId
    }))
}
